import { twMerge } from "tailwind-merge";
import { CARD_BRAND_ICONS } from "@/features/payment/constants/cardBrandIcons";

type SizeDimensions = { width?: number; height?: number };

const SIZE_CONFIG: Record<"xs" | "md", SizeDimensions> = {
  xs: { width: 28, height: 18 },
  md: { width: 44, height: 28 },
};

export interface CardBrandIconProps {
  brand: string;
  size?: keyof typeof SIZE_CONFIG | SizeDimensions;
  className?: string;
}

export function CardBrandIcon({
  brand,
  size = "md",
  className,
}: CardBrandIconProps) {
  const Icon = CARD_BRAND_ICONS[brand.toLowerCase()];

  if (!Icon) return null;

  const { width, height } = typeof size === "string" ? SIZE_CONFIG[size] : size;

  return (
    <Icon
      role="img"
      aria-label={brand}
      width={width}
      height={height}
      className={twMerge("shrink-0", className)}
    />
  );
}
